import { queryClient } from 'api/services/queryClient';
import { useServices } from 'containers/services';
import { useAppNotifications } from 'hooks';
import type { DeletePersonArg, DeletePersonResult } from 'lib/services/personsApi';
import { type MutationOptions, useMutation, type UseMutationResult } from 'react-query';
import { getErrorMessage } from 'utils/getErrorMessage';
import { MUTATION_KEYS, QUERY_KEYS } from 'utils/queryKeys';

export const useDeletePerson = ({
  onSuccess,
}: Pick<MutationOptions<DeletePersonResult, unknown, DeletePersonArg>, 'onSuccess'> = {}): UseMutationResult<
  DeletePersonResult,
  unknown,
  DeletePersonArg
> => {
  const { personsApiClient } = useServices();
  const appNotification = useAppNotifications();

  return useMutation(async (arg: DeletePersonArg) => await personsApiClient.delete(arg), {
    mutationKey: MUTATION_KEYS.persons.deleteOne(),
    onError: error => {
      appNotification.error({
        message: 'There was an error while deleting person',
        description: getErrorMessage(error),
      });
    },
    onSuccess: (data, variables, context) => {
      appNotification.success({
        message: `Person deleted`,
      });
      queryClient.invalidateQueries(QUERY_KEYS.persons.all());
      queryClient.invalidateQueries(QUERY_KEYS.customers.all());
      onSuccess?.(data, variables, context);
    },
  });
};
